import React, { useRef, useEffect } from 'react';
import '../css/remixicon/remixicon.css'; 
import '../css/common.css'; 
import { Link } from "react-router-dom";
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const NotFound = () => {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.play().catch((error) => {
                // console.error("Video playback failed:", error);
            });
        }
    }, []);

    return (
        <div className='flex-1 d-flex justify-content-center align-items-center'>
            <div className='notFound-area notFound-form'>
                <h1>404</h1>
                <p>페이지를 찾을 수 없습니다.</p>
                <Link to="/" class="btn-red">홈으로 돌아가기</Link>
            </div>

         
        </div>
      );
};

export default NotFound;


